import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SynamediaClients from '../components/SynamediaClients'
import { showDialog } from '../redux/actions/MainDialog'
import HistogramC from './HistogramC'
import SynamediaClientsApi from "../utils/SynamediaClientsApi";
import { setB2bComapny, setB2bList } from '../redux/actions/histogram'

class SynamediaClientsPc extends Component {
    state = {
        permissions: {}
    }

    componentDidMount() {
        if (this.props.userId){
            this.fetchData({company: this.props.company})
        } else {
            this.setState({permissions: {}})
        }
    }

    componentDidUpdate(prevProps){
        if (this.isChanged(prevProps.userId, this.props.userId) || this.isChanged(prevProps.company, this.props.company)){
            if (this.props.userId){
                this.fetchData({company: this.props.company})
            } else {
                this.setState({permissions: {}})
            }
        }
    }

    isChanged(prevValue, newValue){
        //return ((newValue) && (!prevValue || newValue !== prevValue))
        return newValue !== prevValue
    }

    fetchData = params => {
        SynamediaClientsApi.getSynamediaUserPermissions(params,(data)=>{
            let company = params.company
            const { dispatch } = this.props
            if (data.b2bList && data.b2bList.length > 0){
                company = data.b2bList[0]
                dispatch(setB2bList(data.b2bList, company))
            } else {
                dispatch(setB2bComapny(company))
            }
            this.setState({permissions: data})
        }, (error) => {
            this.setState({permissions: {}})
            /*const { dispatch } = this.props
            dispatch(showDialog('Error', error.error))*/
        })
    }

    showMessageDialog = (title, content) => {
        const {dispatch} = this.props

        dispatch(showDialog(title, content, true))
    }

    render() {
        const { b2bCompany } = this.props
        const { permissions } = this.state

        return (
            <Fragment>
                {(b2bCompany &&(permissions.Admin || permissions.businessUser|| permissions.JHAdmin))?
                    <SynamediaClients company={b2bCompany} permissions={permissions} showMessageDialog={this.showMessageDialog}/>
                    :<HistogramC histogramType={'main'} />}
            </Fragment>
        )
    }
}

function mapStateToProps(state) {
    const { b2bCompany } = state.histogramData
    const { isAuthed, userInfo } = state.authUser;

    const userId = userInfo._id

    return {
        isAuthed, userId, b2bCompany
    }
}

export default connect(mapStateToProps)(SynamediaClientsPc)